import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;

/* eslint-disable camelcase */
import { css } from "styled-components";
import { getThemeData, createStyleComponent } from "@hzero-front-ui/core";
var pictureStyle = function pictureStyle(props) {
  var _getThemeData = getThemeData(props, "common"),
    fontColor = _getThemeData.fontColor,
    disabledColor = _getThemeData.disabledColor;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .c7n-pro-modal.c7n-pro-modal.c7n-pro-picture-viewer-modal {\n      .c7n-pro-modal-content {\n        background: none;\n\n        .c7n-pro-modal-body {\n          .c7n-pro-picture-viewer-btn,\n          .c7n-pro-picture-viewer-btn:hover {\n            color: ", ";\n            &.c7n-pro-btn-disabled {\n              color: ", ";\n            }\n            .icon.icon {\n              font-size: 24px;\n            }\n          }\n        }\n      }\n    }\n  "])), fontColor || "#fff", disabledColor);
};
export default createStyleComponent("picture", pictureStyle);